module.exports = __webpack_public_path__ + "static/media/47-iveco.89ec946a.jpg";